var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.036 13.4167C16.036 13.7788 15.7424 14.0724 15.3803 14.0724H3.54729C3.18516 14.0724 2.8916 13.7788 2.8916 13.4167V13.4167C2.8916 13.0546 3.1867 12.761 3.54882 12.761V12.761V8.19153C3.54882 4.92096 6.19742 2.27002 9.4638 2.27002C12.7302 2.27002 15.3788 4.92096 15.3788 8.19153V12.761V12.761C15.7409 12.761 16.036 13.0546 16.036 13.4167V13.4167ZM4.86326 12.761H14.0643V8.19153C14.0643 5.6455 12.0046 3.58139 9.4638 3.58139C6.92299 3.58139 4.86326 5.6455 4.86326 8.19153V12.761ZM7.9815 15.4352C7.80695 15.071 8.14814 14.7281 8.552 14.7281H10.3756C10.7795 14.7281 11.1206 15.071 10.9461 15.4352C10.8665 15.6014 10.7586 15.7545 10.6256 15.8872C10.3175 16.1946 9.89956 16.3673 9.4638 16.3673C9.02804 16.3673 8.61012 16.1946 8.30199 15.8872C8.16898 15.7545 8.06113 15.6014 7.9815 15.4352Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.e88bf07db768e74fc93b1fd320059d20.svg";
export { ForwardRef as ReactComponent };